<template>
  <div class="edit-video-box">
    <el-dialog :title="'视频编辑'" :visible.sync="dialogVisible" width="800px" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="form" :model="editParam" :rules="rules" label-position="left" label-width="160px">
        <div class="form-flex-box">
          <el-form-item label="视频标题:">
            <el-input type="textarea" :rows="2" placeholder="请谨慎修改用户上传数据" v-model="editParam.title"
              :disabled="editTitle"></el-input>
            <el-button type="success" size="small" @click="editTitle = false">修改</el-button>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="视频内容:">
            <el-input type="textarea" :rows="2" placeholder="请谨慎修改用户上传数据" v-model="editParam.content"
              :disabled="editContent"></el-input>
            <el-button type="success" size="small" @click="editContent = false">修改</el-button>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="预览链接:">
            <el-input type="textarea" :rows="2" placeholder="请谨慎修改预览链接,不能包含域名" v-model="editParam.previewURL"
              :disabled="editPreviewURL"></el-input>
            <el-button type="success" size="small" @click="editPreviewURL = false">修改</el-button>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="点赞数(假):" prop="fakeLikeCount">
            <el-input v-model.number="editParam.fakeLikeCount" size="small" placeholder="请输入假点赞数"></el-input>
          </el-form-item>
          <el-form-item label="播放数(假):" prop="fakePlayCount">
            <el-input v-model.number="editParam.fakePlayCount" max="1" size="small" placeholder="请输入假播放数"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="价格:" prop="coins">
            <el-input v-model.number="editParam.coins" size="small" placeholder="请输入价格"></el-input>
          </el-form-item>
          <el-form-item label="免费时长:" prop="freeTime">
            <el-input v-model="editParam.freeTime" size="small" placeholder="请输入视频免费时长"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="精选值:" prop="recoWeight">
            <el-input v-model.number="editParam.recoWeight" size="small" placeholder="请输入精选值"></el-input>
          </el-form-item>
          <el-form-item label="审核状态:" prop="status">
            <el-select v-model.number="editParam.status" placeholder="请选择审核状态" size="small">
              <el-option label="通过" :value="1"></el-option>
              <el-option label="未通过" :value="2"></el-option>
              <el-option label="下架" :value="5"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="分享数(假):" prop="fakeShareCount">
            <el-input v-model.number="editParam.fakeShareCount" size="small" placeholder="请输入假分享数"></el-input>
          </el-form-item>
          <el-form-item label="打赏金额(假):" prop="fakeRewarded">
            <el-input v-model.number="editParam.fakeRewarded" size="small" placeholder="请输入假打赏金额"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="广告排序号:" prop="sortCode">
            <el-input v-model.number="editParam.sortCode" size="small"></el-input>
          </el-form-item>
          <el-form-item label="作品排序号:" prop="worksSort">
            <el-input v-model.number="editParam.worksSort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="置顶排序号:" prop="liaoBaTopSort">
            <el-input v-model.number="editParam.liaoBaTopSort" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否幸福广场置顶:" prop="happinessPlazaTop">
            <el-switch v-model="isHappinessPlazaTop"></el-switch>
          </el-form-item>
          <!-- <el-form-item label="幸福广场排序号:" prop="happinessPlazaTop">
            <el-input v-model.number="editParam.happinessPlazaTop" size="small"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="专题排序号:" prop="liaoBaTopSort">
            <el-input v-model.number="editParam.liaoBaTopSort" size="small"></el-input>
          </el-form-item> -->
        </div>
        <div class="form-flex-box" v-for="(item, i) in editParam.tagSort" :key="i">
          <el-form-item label="标签排序:">
            <el-input v-model="item.tagName" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item label="排序号:">
            <el-input v-model.number="item.sortCode" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="用户ID:" prop="publisherID">
            <el-input v-model.number="editParam.publisherID" size="small" placeholder="请输入用户ID"></el-input>
          </el-form-item>
          <el-form-item label="是否短视频展示:" prop="isTiktok">
            <el-select v-model.number="editParam.isTiktok" placeholder="请选择是否短视频展示" size="small">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="分享排序值:">
            <el-input v-model.number="editParam.shareSort" size="small"></el-input>
          </el-form-item>
          <el-form-item label="帖子类型:">
            <el-select v-model="editParam.newsType" placeholder="请输入帖子类型" size="small" style="width: 180px">
              <el-option v-for="item in newsTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="种子下载链接:" prop="seedLinkUrl" v-if="isShowZz">
            <el-input type="textarea" v-model="editParam.seedLinkUrl" size="small"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="快捷链接名" prop="quickLinkName">
          <el-input v-model="editParam.quickLinkName" style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item label="快捷跳转方式:" prop="quickLinkType">
          <el-select v-model.number="editParam.quickLinkType" size="small" placeholder="快捷跳转方式" class="activity-box">
            <el-option v-for="item in linkTypeList" :value="item.value" :label="item.label"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" prop="quickLinkUrl" v-if="editParam.quickLinkType == 1">
          <el-input v-model="editParam.quickLinkUrl" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="快捷链接地址:" prop="quickLinkUrl" v-if="editParam.quickLinkType == 0">
          <el-select v-model="editParam.quickLinkUrl" size="small" placeholder="快捷链接地址" filterable class="activity-box">
            <el-option v-for="item in linkList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内链ID" prop="topicId" v-if="isShowInnerId">
          <el-input v-model="topicId" style="width: 100%;"></el-input>
        </el-form-item>
        <div class="form-flex-box" v-if="isShowZz">
          <el-form-item label="种子影片时长:" prop="seedPlayTime">
            <el-input v-model.number="editParam.seedPlayTime" size="small"></el-input>
          </el-form-item>
          <el-form-item label="种子影片大小:" prop="seedSize">
            <el-input v-model.number="editParam.seedSize" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="女优ID:" prop="actors">
            <el-select v-model="editParam.actors" multiple filterable allow-create default-first-option
              placeholder="请输入绑定女优ID" class="activity-box">
              <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="form-flex-box">
          <el-form-item label="广告跳转链接:" prop="linkUrl">
            <el-input type="textarea" v-model="editParam.linkUrl" size="small"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="选择活动:">
          <el-select v-model="editParam.activityId" filterable placeholder="未选择活动则该视频不参加大赛" clearable
            class="activity-box">
            <el-option v-for="item in activityList" :key="item.id" :label="item.desc" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频权限:">
          <el-select v-model="editParam.permission" filterable placeholder="未选择视频权限" clearable class="activity-box">
            <el-option v-for="item in videoPermissionTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tags">
            <tag-selector v-model="editParam.tags" :tagList="tagList"></tag-selector>
          </el-form-item>
        </div>
        <el-form-item label="封面上传:" prop="cover">
          <base-upload :cover="editParam.cover" :action="action" @successCallback="successCallback" :id="sourceID"
            :wSize="360" :hSize="640" :width="'120px'" :height="'213px'"></base-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitDate()" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import {
  validatorIndex,
  validatorOver3,
  validatorWorksSort,
  validatorLiaoBaTopSort,
} from "@/utils/validator";
import API from "@/api";
import TagSelector from "@/components/tagSelector";
import { videoPermissionTypes } from "../../../../config";
export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      dialogVisible: false,
      flag: false,
      isEdit: true,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      tagList: [], //标签列表：包含标签名称和标签id
      sourceID: "",
      editTitle: true,
      editContent: true,
      editPreviewURL: true,
      editParam: {
        id: "",
        tags: [],
        tagSort: [],
        cover: "",
        coverThumb: "",
        title: "",
        content: "",
        status: "",
        fakeLikeCount: 0,
        fakePlayCount: 0,
        fakeShareCount: 0,
        fakeRewarded: 0,
        likeCount: 0,
        playCount: 0,
        shareCount: 0,
        freeTime: "",
        recoWeight: 0,
        coins: 0,
        linkUrl: "",
        sortCode: "",
        isTiktok: false,
        type: 0,
        worksSort: "",
        liaoBaTopSort: "",
        happinessPlazaTop: "",
        activityId: "",
        publisherID: "",
        shareSort: 0,
        newsType: "",
        seedSize: 0,
        seedPlayTime: 0,
        seedLinkUrl: "",
        actors: "",
        previewURL: "",
        quickLinkType: undefined,
        quickLinkName: "",
        quickLinkUrl: "",
        permission: 0
      },
      topicId: undefined,
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 0 },
      ],
      linkList: [
        { label: "会员中心", value: "yinseinner://vip_page" },
        { label: "金币钱包", value: "yinseinner://wallet_page" },
        { label: "抽奖", value: "yinseinner://Activity_page" },
        { label: "帖子详情页", value: "yinseinner://postdetail?id=" },
        { label: "视频详情", value: "yinseinner://video_page?id=" },
      ],
      actorList: [],
      isHappinessPlazaTop: false,
      activityList: [],
      videoPermissionTypes,
      newsTypes: [
        {
          label: "短视频",
          value: "SP",
        },
        {
          label: "长视频",
          value: "MOVIE",
        },
        {
          label: "图集",
          value: "COVER",
        },
        {
          label: "种子贴",
          value: "SEED_LINK",
        },
        {
          label: '黄游帖子',
          value: 'YELLOW_GAME'
        }
      ],
      // 表单验证规则
      rules: {
        cover: [
          { required: true, message: "请输入添加封面图片", trigger: "blur" },
        ],
        fakeLikeCount: [
          { required: true, message: "请输入假点赞数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
          { validator: this.validatorLike, trigger: "blur" },
        ],
        fakePlayCount: [
          { required: true, message: "请输入假播放数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
          { validator: this.validatorPlayer, trigger: "blur" },
        ],
        fakeShareCount: [
          { required: true, message: "请输入假共享数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
          { validator: this.validatorShare, trigger: "blur" },
        ],
        fakeRewarded: [{ validator: validatorIndex, trigger: "blur" }],
        freeTime: [
          { required: true, message: "请输入免费时长", trigger: "blur" },
          { validator: validatorOver3, trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        tags: [{ required: true, message: "请选择标签", trigger: "blur" }],
        coins: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        worksSort: [{ validator: validatorWorksSort, trigger: "blur" }],
        liaoBaTopSort: [{ validator: validatorLiaoBaTopSort, trigger: "blur" }],
        happinessPlazaTop: [
          { validator: validatorLiaoBaTopSort, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    isShowZz() {
      return this.editParam.newsType === 'SEED_LINK' || this.editParam.newsType === 'YELLOW_GAME'
    },
    isShowInnerId() {
      return this.editParam.quickLinkUrl.indexOf('id=') >= 0
    }
  },
  methods: {
    async getVideoActivity() {
      const params = {};
      let ret = await API.getVideoActivity(params);
      if (ret.code == 200) {
        this.activityList = ret.data;
        this.activityList = this.activityList.concat([
          {
            id: "000000000000000000000000",
            desc: "不参加活动",
          },
        ]);
      }
    },
    getTagList() {
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
    // 提交验证
    submitDate() {
      if (this.editParam.freeTime) {
        this.editParam.freeTime = Number(this.editParam.freeTime);
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (
            this.isShowInnerId &&
            !this.topicId
          ) {
            this.$message({
              type: "error",
              message: "请输入专题ID",
            });
            return;
          }
          if (this.isShowInnerId) {
            this.editParam.quickLinkUrl =
              this.editParam.quickLinkUrl + this.topicId;
          }
          this.flag = true;
          const tags = this.editParam.tags.filter(
            (item) => this.tagList.map((e) => e.name).indexOf(item) === -1
          );
          if (tags.length > 0) {
            this.$confirm(
              `标签${tags.join(",")}不属于常用标签，确定修改？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.editVideo();
              })
              .catch(() => {
                this.flag = false;
                return false;
              });
          } else {
            this.editVideo();
          }
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 编辑
    editVideo() {
      if (!this.editParam.activityId) {
        this.editParam.activityId = "000000000000000000000000";
      }
      if (
        this.editParam.previewURL &&
        this.editParam.previewURL.indexOf("http") != -1
      ) {
        this.$message({
          message: "预览视频链接不能包含域名!",
          type: "warning",
        });
        return;
      }
      this.editParam.happinessPlazaTop = this.isHappinessPlazaTop ? 1 : 0;
      API.editVideoInfo(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerVideoList");
          } else {
            this.$message.error("编辑失败！");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.editParam.cover = res.data.coverImg;
      this.editParam.coverThumb = res.data.coverImg;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.getTagList();
      this.getVideoActivity();
      this.dialogVisible = true;
      this.editParam.id = data.id;
      this.isEdit = data.status === 2 ? false : true;
      this.editParam.status = data.status;
      this.editParam.cover = data.cover;
      this.editParam.title = data.title;
      this.editParam.content = data.content;
      this.editParam.coverThumb = data.coverThumb;
      this.editParam.activityId = data.activityId;
      this.editParam.fakeLikeCount = data.fakeLikeCount;
      this.editParam.fakePlayCount = data.fakePlayCount;
      this.editParam.fakeShareCount = data.fakeShareCount;
      this.editParam.fakeRewarded = Number(data.fakeRewarded);
      this.editParam.likeCount = data.likeCount;
      this.editParam.playCount = data.playCount;
      this.editParam.shareCount = data.shareCount;
      this.editParam.freeTime = data.freeTime;
      this.editParam.isChosen = data.chosen;
      this.editParam.coins = data.coins;
      this.editParam.recoWeight = data.recoWeight;
      // console.log(data.recoWeight);
      // console.log(this.editParam.recoWeight);
      this.editParam.linkUrl = data.linkUrl;
      this.editParam.sortCode = data.sortCode;
      this.editParam.isTiktok = data.isTiktok;
      this.editParam.worksSort = data.worksSort;
      this.editParam.liaoBaTopSort = data.liaoBaTopSort;
      this.editParam.actors = data.actorIDs;
      // this.editParam.happinessPlazaTop = data.happinessPlazaTop;
      this.editParam.happinessPlazaTop = data.happinessPlazaTop == 1 ? 1 : 0;
      this.isHappinessPlazaTop =
        this.editParam.happinessPlazaTop == 1 ? true : false;
      this.sourceID = data.sourceID;
      this.editParam.tags = data.tags ? data.tags.map((item) => item.name) : [];
      this.editParam.tagSort = data.tagSort ? data.tagSort : [];
      this.editParam.publisherID = data.publisher.uid;
      this.editParam.shareSort = data.shareSort;
      this.editParam.newsType = data.newsType;
      this.editParam.seedSize = data.seedSize;
      this.editParam.seedPlayTime = data.seedPlayTime;
      this.editParam.seedLinkUrl = data.seedLinkUrl;
      this.editParam.previewURL = data.previewURL;
      this.editParam.quickLinkType = data.quickLinkType;
      this.editParam.quickLinkName = data.quickLinkName;
      this.editParam.permission = data.permission;
      this.editParam.quickLinkUrl = data.quickLinkUrl
      if (this.isShowInnerId) {
        console.log(123123);
        // this.form.link_url = "yinseinner://topic_page";
        const splitArr = data.quickLinkUrl.split("=");
        this.editParam.quickLinkUrl = splitArr[0] + "=";
        this.topicId = splitArr[1];
      } else {
        this.editParam.quickLinkUrl = data.quickLinkUrl;
      }
    },
    // 关闭回掉
    handleClose() {
      this.flag = false;
      this.dialogVisible = false;
      this.isEdit = true;
      this.editTitle = true;
      this.editContent = true;
      this.editPreviewURL = true;
      this.$refs.form.resetFields();
    },
    // 验证播放数
    validatorPlayer(rule, value, callback) {
      if (value >= this.editParam.playCount) {
        callback();
      } else {
        callback(
          new Error(
            "假播放数必须大于或者等于真播放数（当前真播放数为:" +
            this.editParam.playCount +
            "）"
          )
        );
      }
    },
    // 验证点赞数
    validatorLike(rule, value, callback) {
      if (value >= this.editParam.likeCount) {
        callback();
      } else {
        callback(
          new Error(
            "假点赞数必须大于或者等于真点赞数（当前真点赞数为:" +
            this.editParam.likeCount +
            "）"
          )
        );
      }
    },
    // 验证点赞数
    validatorShare(rule, value, callback) {
      if (value >= this.editParam.shareCount) {
        callback();
      } else {
        callback(
          new Error(
            "假共享数必须大于或者等于真共享数（当前真共享数为:" +
            this.editParam.shareCount +
            "）"
          )
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }

  .activity-box {
    /deep/ .el-input {
      // width: 520px !important;
      width: 100%;
    }
  }

  /deep/ .el-select {
    width: 100%;
    max-height: 146px;
  }

  /deep/ .el-form-item__content {
    display: flex;
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }
}
</style>
